import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Play } from '../../../assets/icons/play.svg'
import Popup from '../../Popup/Popup'
import Chatbot from '../Chatbot'

import styles from './chatbot-popup.module.scss'

function ChatbotPopup() {
    const { t } = useTranslation()

    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <button
                className={styles.chatbotPopup__btn}
                onClick={() => setIsOpen(true)}
            >
                <Play />
                {t('talk_to_chatbot')}
            </button>
            <Popup
                isOpen={isOpen}
                closePopup={() => setIsOpen(false)}
                className={styles.chatbotPopup__popup}
            >
                <Chatbot />
            </Popup>
        </>
    )
}

export default ChatbotPopup
